import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Portal/PortalUsage.mdx";

import Examples from "../../Docs/Components/Portal/PortalExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Portal"
            description="Create a React portal quickly and easily using the portal component."
            apiSources={["azure-devops-ui/Components/Portal/Portal.Props.d.ts"]}
            examples={Examples}
            usage={Usage}
        />
    );
}
}
        
export default Page;